<template>
    <div id="app">
        <router-view />
    </div>
</template>

<script>
//import Portal from '@arcgis/core/portal/Portal';
//import OAuthInfo from '@arcgis/core/identity/OAuthInfo';
//import esriId from '@arcgis/core/identity/IdentityManager';

import { loadModules } from "esri-loader";

export default {
    updated() {
        this.checkAuthentication();
    },
    mounted() {
        document.title = "vesselXchange";
        this.$store.state.portalUrl = "https://abcl.maps.arcgis.com";
        this.$store.state.appId = "QaAzUg6wk6pAuSVK"; // Probably needs to be changed from the appId of bargeXchange

        this.runAuthentication();
    },
    methods: {
        checkAuthentication: function () {
            const esriOAuth = window.sessionStorage.getItem("esriJSAPIOAuth");

            if (esriOAuth == null) {
                this.runAuthentication();
                return;
            }

            const esriOAuthJSON = JSON.parse(esriOAuth);
            const expires =
                esriOAuthJSON["/"][this.$store.state.portalUrl]["expires"];

            if (expires <= new Date().getTime() / 1000) {
                this.runAuthentication();
            }
        },
        runAuthentication: function () {
            const globv = this;

            loadModules(
                [
                    "esri/portal/Portal",
                    "esri/identity/OAuthInfo",
                    "esri/identity/IdentityManager",
                ],
                { css: true }
            ).then(async function ([Portal, OAuthInfo, esriId]) {
                // Construct portal if not present
                if (!globv.cortal) {
                    const oAuthInfo = new OAuthInfo({
                        appId: globv.$store.state.appId,
                        portalUrl: globv.$store.state.portalUrl,
                        popup: true,
                        expiration: 120,
                    });

                    esriId.registerOAuthInfos([oAuthInfo]);
                    globv.cortal = new Portal({
                        allSSL: true,
                        authMode: "immediate", // TODO: Currently auto for testing
                        url: globv.$store.state.portalUrl,
                    });
                }

                // Trigger a login popup
                globv.cortal
                    .load()
                    .then(() => {
                        if (globv.cortal.loadError != null) {
                            globv.showUnauthorized(globv.cortal.loadError);
                        }
                    })
                    .catch((error) => {
                        globv.showUnauthorized(error);
                    });
            });
        },
        showUnauthorized: function (loadError) {
            if (this.$route.path != "403") {
                this.$router.push("403").catch(() => {});
            }
        },
    },
};
</script>

<style lang="scss">
body {
    margin: 0;
    height: 100vh;
}

#app {
    font-family: "Avenir", Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
}

@import "./styles/main.scss";
@import "./styles/component.scss";
</style>
